import { ExceptionClass } from 'src/exceptions/ExceptionClass';

export default class API_Exceptions extends ExceptionClass {
  public constructor() {
    super();
  }
}
